import { Alert, AlertIcon, AlertTitle, AlertDescription } from "@chakra-ui/react";
import { FC } from "react";

interface UnsupportedVideoFallbackProps {
  url: string;
}

/**
 * Shown in non-production environments (e.g. Prismic preview, local dev)
 * when an unrecognised video URL is provided.
 *
 * Renders nothing on production so the live page is never broken.
 */
const UnsupportedVideoFallback: FC<UnsupportedVideoFallbackProps> = ({
  url,
}) => {
  if (process.env.NODE_ENV === "production") {
    return null;
  }

  return (
    <Alert
      status="warning"
      flexDirection="column"
      alignItems="flex-start"
      borderRadius="intermediate"
      p="space-16"
    >
      <AlertIcon mb="space-8" />
      <AlertTitle mb="space-4">Unsupported video URL</AlertTitle>
      <AlertDescription fontSize="sm" wordBreak="break-all">
        The URL <strong>{url}</strong> could not be matched to a supported
        video provider (YouTube ID, Vimeo, Loom, or a direct .mp4/.webm file).
        Please check the Video Bloc settings in Prismic.
      </AlertDescription>
    </Alert>
  );
};

export default UnsupportedVideoFallback;
